export default __webpack_public_path__ + "35fcd509a0e6982753b537d270ccaa79.svg";